"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _DurationsPlot = _interopRequireDefault(require("web/shared/telemetry/charts/DurationsPlot"));
var _perfViewsStyles = require("web/shared/telemetry/perfViews.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* Durations plotted against when the work happened.
*
* The chart that separates "it got slower" from "it was always this spread
* out": a step up after a deploy shows as a step here, where in the
* distribution it is only a wider hump.
*/
function DurationsOverTime(_ref) {
  let records = _ref.records;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.panel)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.subHeading)), {}, {
      children: "Over Time"
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.panelDescription)), {}, {
      children: "Plotted against when the work happened, so a step up after a deploy shows as a step rather than as a wider spread."
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DurationsPlot.default, {
      records: records
    })]
  }));
}
var _default = exports.default = DurationsOverTime;